let player = [];
let currentPlayer;
let timer = [];

angular.module('benefitsComparison', [])
    .controller('benefitsComparisonCtrl',['$sce', '$http', function($sce, $http) {
        var benefitsScope = this;
        const LEXUS_INDEX = 0;
        const BMW_INDEX = 1;
        const MERCEDES_INDEX = 2;
        const AUDI_INDEX = 3;
        benefitsScope.vehicles = []
        benefitsScope.selectedName = "";
        benefitsScope.selectedNameTwo = "";
        var vehiclesCompareContent = [];

        $http.get('public/scripts/compare-vehicle.json')
        .then(function(response) {
            setVehicleData(response);
        });

        function setVehicleData (response) {
            const vehicles = response.data.vehicles;
            vehiclesCompareContent = response.data.vehiclesProperty;
            benefitsScope.selectedName = vehicles[0];
            benefitsScope.selectedNameTwo = vehicles[1];
            benefitsScope.vehicles = vehicles;

            benefitsScope.selectVehicleHandler = function() {
                const indexVehicle = vehicles.indexOf(benefitsScope.selectedName);
                switch (indexVehicle) {
                    case LEXUS_INDEX:
                        benefitsScope.limitedWarranty = $sce.trustAsHtml(vehiclesCompareContent[LEXUS_INDEX][0]);
                        benefitsScope.inspection = vehiclesCompareContent[LEXUS_INDEX][1];
                        benefitsScope.assistanceRoad = vehiclesCompareContent[LEXUS_INDEX][2]
                        benefitsScope.complimentaryService = vehiclesCompareContent[LEXUS_INDEX][3]
                        benefitsScope.exchangePolicy = vehiclesCompareContent[LEXUS_INDEX][4]
                        benefitsScope.tripInterruption = vehiclesCompareContent[LEXUS_INDEX][5];
                        break;
                    case BMW_INDEX:
                        benefitsScope.limitedWarranty = $sce.trustAsHtml(vehiclesCompareContent[BMW_INDEX][0]);
                        benefitsScope.inspection = vehiclesCompareContent[BMW_INDEX][1];
                        benefitsScope.assistanceRoad = vehiclesCompareContent[BMW_INDEX][2];
                        benefitsScope.complimentaryService = vehiclesCompareContent[BMW_INDEX][3]
                        benefitsScope.exchangePolicy = vehiclesCompareContent[BMW_INDEX][4]
                        benefitsScope.tripInterruption = vehiclesCompareContent[BMW_INDEX][5];
                        break;
                    case MERCEDES_INDEX:
                        benefitsScope.limitedWarranty = $sce.trustAsHtml(vehiclesCompareContent[MERCEDES_INDEX][0]);
                        benefitsScope.inspection = vehiclesCompareContent[MERCEDES_INDEX][1];
                        benefitsScope.assistanceRoad = vehiclesCompareContent[MERCEDES_INDEX][2];
                        benefitsScope.complimentaryService = vehiclesCompareContent[MERCEDES_INDEX][3]
                        benefitsScope.exchangePolicy = vehiclesCompareContent[MERCEDES_INDEX][4]
                        benefitsScope.tripInterruption = vehiclesCompareContent[MERCEDES_INDEX][5];
                        break;
                    case AUDI_INDEX:
                        benefitsScope.limitedWarranty = $sce.trustAsHtml(vehiclesCompareContent[AUDI_INDEX][0]);
                        benefitsScope.inspection = vehiclesCompareContent[AUDI_INDEX][1];
                        benefitsScope.assistanceRoad = vehiclesCompareContent[AUDI_INDEX][2];
                        benefitsScope.complimentaryService = vehiclesCompareContent[AUDI_INDEX][3]
                        benefitsScope.exchangePolicy = vehiclesCompareContent[AUDI_INDEX][4]
                        benefitsScope.tripInterruption = vehiclesCompareContent[AUDI_INDEX][5];
                        break;

                    default:
                        break;
                }
            };

            benefitsScope.selectVehicleHandlerTwo = function() {
                const indexVehicle = vehicles.indexOf(benefitsScope.selectedNameTwo);
                switch (indexVehicle) {
                    case LEXUS_INDEX:
                        benefitsScope.limitedWarrantyTwo = $sce.trustAsHtml(vehiclesCompareContent[LEXUS_INDEX][0]);
                        benefitsScope.inspectionTwo = vehiclesCompareContent[LEXUS_INDEX][1];
                        benefitsScope.assistanceRoadTwo = vehiclesCompareContent[LEXUS_INDEX][2]
                        benefitsScope.complimentaryServiceTwo = vehiclesCompareContent[LEXUS_INDEX][3]
                        benefitsScope.exchangePolicyTwo = vehiclesCompareContent[LEXUS_INDEX][4]
                        benefitsScope.tripInterruptionTwo = vehiclesCompareContent[LEXUS_INDEX][5];
                        break;
                    case BMW_INDEX:
                        benefitsScope.limitedWarrantyTwo = $sce.trustAsHtml(vehiclesCompareContent[BMW_INDEX][0]);
                        benefitsScope.inspectionTwo = vehiclesCompareContent[BMW_INDEX][1];
                        benefitsScope.assistanceRoadTwo = vehiclesCompareContent[BMW_INDEX][2];
                        benefitsScope.complimentaryServiceTwo = vehiclesCompareContent[BMW_INDEX][3]
                        benefitsScope.exchangePolicyTwo = vehiclesCompareContent[BMW_INDEX][4]
                        benefitsScope.tripInterruptionTwo = vehiclesCompareContent[BMW_INDEX][5];
                        break;
                    case MERCEDES_INDEX:
                        benefitsScope.limitedWarrantyTwo = $sce.trustAsHtml(vehiclesCompareContent[MERCEDES_INDEX][0]);
                        benefitsScope.inspectionTwo = vehiclesCompareContent[MERCEDES_INDEX][1];
                        benefitsScope.assistanceRoadTwo = vehiclesCompareContent[MERCEDES_INDEX][2];
                        benefitsScope.complimentaryServiceTwo = vehiclesCompareContent[MERCEDES_INDEX][3]
                        benefitsScope.exchangePolicyTwo = vehiclesCompareContent[MERCEDES_INDEX][4]
                        benefitsScope.tripInterruptionTwo = vehiclesCompareContent[MERCEDES_INDEX][5];
                        break;
                    case AUDI_INDEX:
                        benefitsScope.limitedWarrantyTwo = $sce.trustAsHtml(vehiclesCompareContent[AUDI_INDEX][0]);
                        benefitsScope.inspectionTwo = vehiclesCompareContent[AUDI_INDEX][1];
                        benefitsScope.assistanceRoadTwo = vehiclesCompareContent[AUDI_INDEX][2];
                        benefitsScope.complimentaryServiceTwo = vehiclesCompareContent[AUDI_INDEX][3]
                        benefitsScope.exchangePolicyTwo = vehiclesCompareContent[AUDI_INDEX][4]
                        benefitsScope.tripInterruptionTwo = vehiclesCompareContent[AUDI_INDEX][5];
                        break;

                    default:
                        break;
                }
            }

            benefitsScope.selectVehicleHandler();
            benefitsScope.selectVehicleHandlerTwo();

        }
    }]);

(function (window, $, undefined) {
    const LAPTOP_BREAKPOINT = '992px';

    const VIDEO_SOURCE = 'https://www.youtube.com/embed/sjCybtvM3jI';

    const YouTubeState = {
        NOT_LOADED: 0,
        LOADING: 1,
        LOADED: 2
    };

    const mediaQuery = window.matchMedia(`(min-width: ${LAPTOP_BREAKPOINT})`);

    let videoComponent;
    let videoHasStarted;
    let youTubeState = YouTubeState.LOADED;
    //for tap
    let pp25, pp50, pp75 = false;
    //

    window.cpo = {
        showVideo
    };

    loadYouTubeApi();

    // YouTube's iframe api will call this method
    window.onYouTubeIframeAPIReady = function () {
        videoComponent = createVideoComponent();
        player[0] = new YT.Player('desktop-video', {
            events: {
                onStateChange: onPlayerStateChange,
                onReady: () => {
                    console.log('desktop-loaded');
                }
            }
        });
    };

    function createVideoComponent() {
        const template = `
            <iframe
                frameborder="0"
                id="cpo-video"
                src="${VIDEO_SOURCE}?enablejsapi=1">
            </iframe>`;

        const videoComponent = new Lightbox(template);

        videoComponent.player = new YT.Player('cpo-video', {
            events: {
                onStateChange: onPlayerStateChange,
                onReady: () => {
                    //youTubeState = YouTubeState.LOADED;
                    //showVideo();
                }
            }
        });

        player[1] = videoComponent.player;

        videoComponent.onClose = function () {
            this.player.pauseVideo();
        };

        videoComponent.onOpen = function () {
            this.player.playVideo();
        };

        return videoComponent;
    }

    function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.PLAYING) {
            if (event.target.getIframe().id == 'desktop-video') {
                currentPlayer = player[0];
            } else {
                currentPlayer = player[1];
            }
            timer = setInterval(getPercentage,100);

            if (!videoHasStarted) {
                //for tap
                if(typeof window.tapYouTube === "function") {
                    window.tapYouTube(0)
                 }
                 //console.log('at 0')
                //
                _satellite.track('benefits_video_start');
            }
            videoHasStarted = true;
        } else if (event.data === YT.PlayerState.ENDED) {
            //for tap
            if(typeof window.tapYouTube === "function") {
                window.tapYouTube(100)
             }
             //console.log('at end')
            //
            _satellite.track('benefits_video_complete');
            clearInterval(timer);
        } else {
            clearInterval(timer);
        }
    }

    $(".cto-program .watch-button").click(cpo.showVideo);
    $("[data-floodLight]").click(onFloodlightClick);

    function getPercentage() {
        let pt = parseInt((currentPlayer.getCurrentTime() / currentPlayer.getDuration()) * 100)
        if (pt < 25) {
            pp25 = pp50 = pp75 = false;
        }
        if (pt >= 25 && pt < 50 ) {
            pp50 = pp75 = false;
        }
        if (pt >= 50 && pt < 75) {
            pp75 = false;
        }

        switch (pt) {
            case 25:
                if (!pp25) {
                    if(typeof window.tapYouTube === "function") {
                        window.tapYouTube(25)
                     }
                    //console.log('at 25');
                    pp25 = true;
                }
                break;
            case 50:
                if (!pp50) {
                    if(typeof window.tapYouTube === "function") {
                        window.tapYouTube(50)
                    }
                    //console.log('at 50');
                    pp50 = true;
                }
                break;
            case 75:
                if (!pp75) {
                    if(typeof window.tapYouTube === "function") {
                        window.tapYouTube(75)
                    }
                    //console.log('at 75');
                    pp75 = true;
                }
                break;
        }
    }



    //desktop video tracking for tap


    function loadYouTubeApi() {
        console.log('api loaded')
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.type = 'text/javascript';
        document.head.appendChild(script);

        //youTubeState = YouTubeState.LOADING;
    }

    function onFloodlightClick() {
        callFloodlight($(this).attr('data-floodLight'));
    }

    function showVideo() {
        if (youTubeState === YouTubeState.NOT_LOADED) {
            return loadYouTubeApi();
        }

        if (youTubeState === YouTubeState.LOADING) {
            return;
        }

        videoComponent.open();

    }

      // awards owl

      var $owl = $('.owl-carousel');

      $owl.owlCarousel({
        loop: false,
        margin: 12,
        dots: true,
        nav: true,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 1
          },
          992: {
            items: 1
          },
          1200: {
            items: 1
          }
        }
      })

      // OWL arrows for Awards section - desktop only
      $(".prev").click(function() {
        $owl.trigger('prev.owl.carousel');
      });

      $(".next").click(function() {
        $owl.trigger('next.owl.carousel');
      });
      // owl end

      // flip owl item - adds '.flipped' to owl item

      var $item_bttn = $('.awards .item .btn');

      $item_bttn.on('click', function(e) {
        $(this).closest('.item').toggleClass("flipped");
        if ($(this).closest('.item').hasClass("flipped")) {
            $(this).closest('.item').find('.btn-left-arrow').attr('aria-hidden','false');
        } else {
            $(this).closest('.item').find('.btn-left-arrow').attr('aria-hidden','true');
        }
        e.preventDefault();
      });
      // flip end

      var benefitsTable = $("#table-wrapper");
        var benefitsTableScrollWidth = benefitsTable[0].scrollWidth;
        var scrollPosition = 0;
        var timeframe;
        var isMobile;

        // if is mobile, add "table-responsive" class
        updateTable();

        window.onresize = function() {
          clearTimeout(timeframe);
          timeframe = setTimeout(updateTable, 300);
        };

        function updateTable() {
            isMobile = window.matchMedia("only screen and (max-width: 47.99em)").matches;

            if (isMobile) {
              // init table scrolled to right
              benefitsTable.addClass("table-responsive").scrollLeft(benefitsTableScrollWidth);

            } else {
              benefitsTable.removeClass("table-responsive");
            }
        }

          // document scroll event
          $(document).on("scroll", function() {
            var tablePosition = benefitsTable[0].getBoundingClientRect();

            // get scroll direction
            var scrollingDown = this.body.getBoundingClientRect().top < scrollPosition;

            if (scrollingDown) {
              // fires when mobile table is partially visible
              if(isMobile && tablePosition.top >= 350) {

                setTimeout(function() {
                  benefitsTable.animate({ scrollLeft: 0 }, function() {
                    // animation complete
                    $(this).stop(true, true);
                  });
                }, 500);
              }
           }

            // saves the new position for iteration
            scrollPosition = this.body.getBoundingClientRect().top;
          });
})(window, jQuery);


